import { AxiosRequestConfig } from "axios";

export interface AxiosJsonParseProfile {
  silent?: boolean;
  forced?: boolean;
  strict?: boolean;
  stringify(data: unknown | any): string;
}

export interface AxiosInterceptorOptions {
  synchronous?: boolean;
  runWhen?: ((config: AxiosRequestConfig) => boolean) | null;
  prio?: number;
}

export interface AxiosInterceptor<V> extends AxiosInterceptorOptions {
  fulfilled?: (value: V) => V | Promise<V>;
  rejected?: (error: any) => any;
}

export type AxiosTransformerFn = (
  this: AxiosRequestConfig,
  data: any,
  headers: any
) => any;

export enum AxiosHandlerType {
  response = "response",
  request = "request"
}

export enum AxiosTransformerType {
  response = "transformResponse",
  request = "transformRequest"
}

export interface AxiosTransformer extends AxiosTransformerFn {
  prio?: number;
}
export type FaseValue = false | undefined | null | void;

export type AxiosDynamicValueFn<T> = (config: AxiosRequestConfig) => T;

export type AxiosDynamicString =
  | string
  | AxiosDynamicValueFn<string | FaseValue>;

declare module "axios" {
  interface AxiosInterceptorManager<V> {
    handlers: (AxiosInterceptor<V> | null)[];
    use<T = V>(
      onFulfilled?: (value: V) => T | Promise<T>,
      onRejected?: (error: any) => any,
      options?: AxiosInterceptorOptions
    ): number;
    forEach(fn: (item: AxiosInterceptor<V>) => void): void;
  }
}
